<script>
import { usePageCommanderProInfosFacturation } from "./mixin";

import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import OrderSummary from "@/containers/order-summary/tunnel-pro";
import OrderDetail from "@/containers/order-summary/detail-pro";
import Popin from "@/components/molecules/popin";
import Card from "@/components/molecules/card";
import LinkTo from "@/components/atoms/link-to";
import InfosFacurationProForm from "@/components/organisms/infos-facturation-pro-form/default";
import CmsFetcher from "@/containers/cms-fetcher";
import MentionsLegalesPro from "@/components/molecules/mentions-legales/pro";

import bandeauLegalVapotage from "@/assets/images/bandeau-legal-vapotage.jpg";
import bandeauLegalAlcool from "@/assets/images/bandeau-legal-alcool.jpg";

export default {
  components: {
    Container,
    LazyImage,
    Icon,
    Badge,
    GridCol,
    GridRow,
    OrderSummary,
    OrderDetail,
    Popin,
    Card,
    InfosFacurationProForm,
    LinkTo,
    Button,
    CmsFetcher,
    MentionsLegalesPro
  },
  setup() {
    const {
      state,
      cgvLink,
      pdpLink,
      magasinName,
      checkout,
      facturationForm,
      error,
      infoNonRetrait,
      setFacturationForm,
      save
    } = usePageCommanderProInfosFacturation();

    return {
      state,
      cgvLink,
      pdpLink,
      magasinName,
      checkout,
      facturationForm,
      error,
      infoNonRetrait,
      setFacturationForm,
      save,
      bandeauLegalVapotage,
      bandeauLegalAlcool
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
    class="c-checkout"
  >
    <Container>
      <GridRow>
        <GridCol cols="9">
          <div class="c-checkout">
            <p class="c-checkout__location u-mt-lg u-mb-sm">
              <Icon
                name="location"
                size="sm"
                class="u-mr-xxs"
              />
              Magasin {{ magasinName }}
            </p>
            <div class="c-checkout__step u-flex u-flex-align-baseline u-mb-md">
              <h2 class="c-checkout__step-title c-checkout__step-title--current">
                <Badge
                  class="c-checkout__step-badge c-checkout__step-badge--current"
                  circle
                >
                  1
                </Badge>
                Modalités de commande
              </h2>
              <LinkTo
                to="/commander-pro"
                class="u-ml-sm"
              >
                Revoir
              </LinkTo>
            </div>

            <div class="c-checkout__step">
              <h1 class="c-checkout__step-title c-checkout__step-title--current">
                <Badge
                  class="c-checkout__step-badge c-checkout__step-badge--current"
                  circle
                >
                  2
                </Badge>
                Informations de facturation
              </h1>
              <div class="c-checkout__step--container">
                <Card
                  radius="md"
                  elevation="sm"
                  class="u-p-md"
                >
                  <InfosFacurationProForm
                    :checkout="checkout"
                    :error="error"
                    :state="state"
                    :model-initial="facturationForm"
                    :info-non-retrait="infoNonRetrait"
                    @displayCgv="$refs.cgvPopin.show()"
                    @save="save"
                    @update="setFacturationForm"
                  />
                </Card>
              </div>
            </div>

            <div class="c-checkout__step ">
              <h2 class="c-checkout__step-title">
                <Badge
                  class="c-checkout__step-badge"
                  circle
                >
                  3
                </Badge>
                Confirmation
              </h2>
            </div>
          </div>

          <MentionsLegalesPro
            class="u-mb-md"
            @displayPdp="$refs.pdpPopin.show()"
          />

          <div class="c-checkout__banner u-text-center">
            <LazyImage
              :src="bandeauLegalAlcool"
              alt="Interdiction de vente de boissons alcooliques aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
              width="739"
              height="101"
            />
          </div>
          <div class="c-checkout__banner u-text-center">
            <LazyImage
              :src="bandeauLegalVapotage"
              alt="Interdiction de vente de produits du vapotage aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
              width="739"
              height="101"
            />
          </div>
        </GridCol>
        <GridCol cols="3">
          <div class="c-checkout__summary">
            <OrderSummary
              class="u-sticky"
              @showOrderDetail="$refs.popinOrderDetail.show()"
            />
          </div>
          <Popin
            ref="popinOrderDetail"
            aria-label="Details de la commande"
            size="lg"
          >
            <OrderDetail />
          </Popin>
        </GridCol>
      </GridRow>
    </Container>
    <Popin
      ref="cgvPopin"
      aria-label="Conditions générales de vente"
      size="lg"
    >
      <CmsFetcher :link="cgvLink" />
      <div class="u-flex u-flex-justify-center">
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-m-sm"
          @click="$refs.cgvPopin.hide()"
        >
          OK
        </Button>
      </div>
    </Popin>
    <Popin
      ref="pdpPopin"
      aria-label="Politique données personnelles"
      size="lg"
    >
      <CmsFetcher :link="pdpLink" />
      <div class="u-flex u-flex-justify-center">
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-m-sm"
          @click="$refs.pdpPopin.hide()"
        >
          OK
        </Button>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/checkout.scss";
.c-checkout-pro__next-btn {
  display: flex;
  width: fit-content;
  margin-left: auto;
}
</style>
